import dayjs from 'dayjs';
// import utc from 'dayjs/plugin/utc';

// dayjs.extend(utc);

export const convertFilters = ({ from, to }) => {
  const params = new URLSearchParams();

  params.append('date_from', dayjs/* .utc */(from).format('YYYY-MM-DD'));
  params.append('date_to', dayjs/* .utc */(to).format('YYYY-MM-DD'));

  return params;
};
